import { render } from "./HeroiconsSolidDocumentAdd.vue?vue&type=template&id=5e04850a"
const script = {}

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocumentAdd.vue"]])

export default __exports__